import styled from 'styled-components';

export const SectionTitle = styled.div`
    color: #000000;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height:26px;
`; 

export const Title = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 40px;
    font-weight: bold;
    line-height: 58px;
    @media screen and (max-width:1199px) {
      font-size: 35px;
      line-height: 40px;
  }
  @media screen and (max-width:991px) {
      font-size: 30px;
      line-height: 35px;
  }
  @media screen and (max-width:575px) {
      font-size: 28px;
      line-height: 40px;
      margin-bottom: 20px;
  }
`;    

export const SectionText = styled.p`
    margin: 30px 0px;
     @media screen and (max-width:575px) {
      margin:0px 0px 20px 0;
     
     }
`;

export const SendEmailsWrap = styled.div`
    margin-bottom: 50px;
    @media screen and (max-width:991px) {
        margin-bottom: 30px;
     }
    &:last-child{
      margin-bottom: 0px;
       word-break: break-word;
    }
`;

export const SendEmailsTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 30px;
    font-weight: bold;
    line-height: 44px;
      @media screen and (max-width:575px) {
         font-size: 25px;
         line-height: 35px;
      }
`;

export const SendEmailsOuterWrap = styled.div`
    width: 100%;
    background:#FFFFFF;
    padding: 20px;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 20px;
    border-radius: 15px;
    box-shadow: 0px 10px 20px #0000001A;
     @media screen and (max-width:575px) {
        margin-top: 20px;
     }
`;

export const SendEmailsContent = styled.div`
    width: 100%;
    background:#F2F2F2;
    padding: 30px;
    border-radius: 20px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
    @media screen and (max-width:575px) {
         padding: 20px;
       
     }
`;

export const SendEmailsText = styled.p`
    margin-bottom: 20px;
    white-space: pre-wrap; 
    margin: 0; 
    &:last-child{
        margin-bottom: 0px;
            word-wrap: break-word;
    }

    &.invite-review-text{
        padding-bottom: 20px;
        &:last-child{
            padding-bottom: 0px;
        }
    }
`;
export const SendEmailsTextArea = styled.textarea`
    width: 100%;
    resize: none;
    white-space: pre-wrap; 
    padding: 0;
    background-color: transparent;
    border: none;

    &:focus-visible{
        outline: none;
    }
`;
export const SendEmailsButtonWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    @media screen and (max-width:575px) {
           flex-wrap: wrap;
    }
`;

export const DownloadButton = styled.button`
    border: none;
    background: transparent;

    &.file-download-btn{
        background: transparent;
        color: #33A7AE;
        font-size: 18px;
        font-family: 'Jost', sans-serif;
        font-weight: 500;
        line-height: 26px;
        cursor: pointer;
        transition: all 0.5s;
        padding-left: 0;

        &:focus-visible{
            box-shadow: none;
        }
        &:hover{
            color: #01606F;
        }
    }
`;

export const CopyButton = styled.button`
    border: none;
    
    &.btn-outline-success-blue{
        padding: 12px 30px;
    }
`;

export const SendEmailsTextSpan = styled.span`
    display: block;
`;

export const EmailSocialMediaButton = styled.div`
    width: 100%;
    display: flex;
    column-gap: 10px;
    margin-top: 20px;
    @media screen and (max-width:575px) {
     flex-wrap: wrap;
      gap: 10px;
      
    }

    
`;

export const SocialMediaButton = styled.button`
    color: #FFFFFF;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 22px;
    padding: 12px 15px;
    padding: 12px 30px;
    border-radius: 10px;
    transition: all 0.5s ease-in-out;

    &.facebook-review-btn{
        background: #466CA5;
           @media screen and (max-width:575px) {
              width:100%;
           }
        &:hover{
            color: #fff;
        }
    }

    &.twitter-review-btn{
        background: #54ADFC;
        @media screen and (max-width:575px) {
              width:100%;
           }
        &:hover{
            color: #fff;
        }
    }
`;


export const SendEmailsList = styled.ol`
    padding-left: 24px;
    margin-bottom: 30px;
`;

export const SendEmailsListText = styled.li`
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
`;